'use strict';

require('core-js/fn/array/includes');
require('core-js/fn/object/assign');

const csrf = require('public/js/lib/csrf/utils');

function withCsrfHeader(requestOpts) {
	if (!csrf.shouldAttachCsrfHeader(requestOpts)) {
		return requestOpts;
	}

	const token = csrf.getCsrfTokenFromMeta() || csrf.getToken();
	if (!token) {
		return requestOpts;
	}
	return csrf.withCsrfHeaderFromConfig(requestOpts, token);
}

module.exports = (requestOpts) => {
	$ajax(withCsrfHeader(requestOpts || {}));
};
